import { Cached, Close, Done } from '@mui/icons-material';
import { palette } from '@innovyze/stylovyze';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material';

import { STATUS_ENUM } from '@Types/editSensorData.types';
import { STATUS } from '@Utils/constants';
import { TFunc } from '../../../i18n/types';

export type ACTION_BAR_TYPE = {
	text: string;
	// eslint-disable-next-line @typescript-eslint/ban-types
	icon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
	iconColor: string;
	textColor: string;
};

export const ACTIONS_STATUS = (t: TFunc): Record<STATUS, ACTION_BAR_TYPE> => ({
	[STATUS_ENUM.PENDING]: {
		text: t('Saving data...'),
		icon: Cached,
		iconColor: palette.secondary.light,
		textColor: palette.secondary.light,
	},
	[STATUS_ENUM.SUCCESS]: {
		text: t('All changes saved'),
		icon: Done,
		iconColor: palette.secondary.light,
		textColor: palette.secondary.light,
	},
	[STATUS_ENUM.ERROR]: {
		text: t('Error while saving'),
		icon: Close,
		iconColor: palette.error.main,
		textColor: palette.error.main,
	},
	[STATUS_ENUM.IDLE]: {
		text: '',
		icon: Cached,
		iconColor: palette.secondary.light,
		textColor: palette.secondary.light,
	},
});
